import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutUs from "../pages/about-us/page";
import OurServices from "../pages/our-services/page";
import OurProducts from "../pages/our-products/page";
import ContactUs from "../pages/contact-us/page";
import TermsOfUse from "../pages/terms-of-use/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import RefundPolicy from "../pages/refund-policy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about-us", element: <AboutUs /> },
  { path: "/our-services", element: <OurServices /> },
  { path: "/our-products", element: <OurProducts /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/terms-of-use", element: <TermsOfUse /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/refund-policy", element: <RefundPolicy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
